import React, { HTMLInputTypeAttribute } from 'react';

import { TextField, FormControl } from '@mui/material';
import { Controller } from 'react-hook-form';

import { getFieldErrorMessage, useFormContext } from '../FormProvider';

interface Props {
  name: string;
  label: string;
  type?: HTMLInputTypeAttribute;
  fullWidth?: boolean;
  disabled?: boolean;
  multiline?: boolean;
  rows?: number;
  margin?: 'none' | 'dense' | 'normal';
  disableAutocomplete?: boolean;
  className?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

export const ControlledTextField: React.FC<Props> = ({
  name,
  label,
  rows = 1,
  type = 'text',
  disabled = false,
  fullWidth = true,
  multiline = false,
  margin = 'normal',
  disableAutocomplete = false,
  className = '',
  inputProps,
}) => {
  const { control, errors } = useFormContext();

  return (
    <FormControl fullWidth={fullWidth} margin={margin} className={className}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            type={type}
            label={label}
            variant="outlined"
            disabled={disabled}
            multiline={multiline}
            rows={rows}
            error={!!errors?.[name]}
            helperText={getFieldErrorMessage(errors?.[name])}
            autoComplete={disableAutocomplete ? 'new-password' : undefined}
            InputProps={disableAutocomplete ? { autoComplete: 'new-password' } : {}}
            inputProps={inputProps}
          />
        )}
      />
    </FormControl>
  );
};
